import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FiltersNewView } from 'src/domains/layouts/webview/components/filters/Filters';
import { FiltersScrollableWrapper } from 'src/domains/layouts/webview/components/filters/FiltersScrollableWrapper';
import { FilterSuppliers } from 'src/domains/casino/webview/CasinoGames/filters-dropdown/FilterSuppliers';
import { CasinoPageState } from 'src/domains/casino/state/AppCasino.state';
import { CasinoFilterWrapper } from './CasinoFilters.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CasinoFiltersPropsType {
    casinoPageState: CasinoPageState;
    isSearchOpen: boolean;
}

export const CasinoFilters = observer('CasinoFilters', (props: CasinoFiltersPropsType) => {
    const { casinoPageState, isSearchOpen } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    return (
        <CasinoFilterWrapper isSearchOpen={isSearchOpen}>
            <FiltersScrollableWrapper
                casinoGradientOverlay={true}
                customHeight={casinoPageState.casinoSearchExt.isDropdownOpen ? 236 : undefined}
            >
                <FiltersNewView
                    skin={configState.filtersVersion.casino}
                    isMultipleLine={false}
                    select={casinoPageState.navigationState.activeTabIdForUrl}
                    filters={casinoPageState.navigationState.filtersHome}
                />
                <FilterSuppliers casinoPageState={casinoPageState} />
            </FiltersScrollableWrapper>
        </CasinoFilterWrapper>
    );
});
